<app-navBar></app-navBar>
<div class="container-preview">
    <router-outlet></router-outlet>
</div>
<app-footer></app-footer>
